module.exports = "/_next/static/images/ntuc-link-card-ff927b19ef9a1e015d7f1f5945b46c78.png";